import { logErrorIfNotWebApiRequestCancellation } from "@faire/retailer-visitor-shared/lib/logErrorIfNotWebApiRequestCancellation";
import { useSearchPageFiltersQueryError } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Filters/useSearchPageFiltersQueryError";
import { useSearchPageQueryError } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageQueryError";
import { useEffect } from "react";
export var SearchPageLogErrorEffect = function() {
    var productError = useSearchPageQueryError();
    var filtersError = useSearchPageFiltersQueryError();
    var error = productError !== null && productError !== void 0 ? productError : filtersError;
    useEffect(function() {
        logErrorIfNotWebApiRequestCancellation(error);
    }, [
        error
    ]);
    return null;
};
